<template>
  <v-select
    outlined
    :multiple="isMultiple && !solo"
    dense
    :items="items"
    :menu-props="{ offsetY: true, contentClass: contentClass }"
    :class="{ focused: isFocused, 'error-input': hasError }"
    v-bind="$attrs"
    @focusin="isFocused = true"
    @focusout="isFocused = false"
    v-on="$listeners"
  >
    <template v-if="needSelection" #item="{ item }">
      <slot name="selection" :item="item" />
    </template>
  </v-select>
</template>

<script>
export default {
  name: "BaseSelect",
  props: {
    items: {
      type: [Array, Object],
      required: true,
    },
    needSelection: {
      type: Boolean,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },

  computed: {
    // multiple if item is more than 1
    isMultiple() {
      if (Array.isArray(this.items)) {
        return this.items.length > 1;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-list-item__title {
  font-size: 14px !important;
}
.focused {
  ::v-deep .v-input__slot {
    color: #2536cc !important;
    box-shadow: 0px 0px 12px 4px #ebf2ff !important;
  }
}
.error-input {
  ::v-deep .v-input__slot {
    color: #ff5267 !important;
    box-shadow: 0px 0px 8px 2px #ffc6c6 !important;
  }
}
::v-deep .v-list-item--link {
  margin: 8px;
  &:hover {
    background: rgba(155, 189, 255, 0.2);
    border-radius: 5px;
    overflow: hidden;
  }
}
::v-deep .v-list-item--active {
  background: rgba(155, 189, 255, 0.2);
  border-radius: 5px;
  overflow: hidden;
}
</style>
